// Port of WaitingScreen() in android/.../ui/MainActivity.kt.
// State: paired + active, but no content has been assigned yet.
// Shows a non-secret device id so support can correlate the browser with a
// Screen row without putting any part of the bearer token on a public display.

import { publicDeviceId } from '../lib/devicePrefs'

export default function WaitingScreen() {
  return (
    <div className="flex w-full max-w-md flex-col items-center gap-2 px-5 text-center">
      <h2 className="text-white text-[clamp(1.25rem,6vw,1.5rem)] font-bold">Screen registered</h2>
      <p className="text-muted text-sm leading-relaxed">
        Waiting for content to be assigned
        <br />from the WeTook dashboard
      </p>
      <p className="text-white/45 text-xs mt-1">Device ID: {publicDeviceId()}</p>
    </div>
  )
}
